$( document ).ready(function() {

  var winWidth = $(window).width();

  $('.masthead--arrow').on('click', function(e) {

    e.preventDefault();

    var curEl         = $($(this).attr('href'));
    var nextOffset    = curEl.next().offset();

    if (winWidth > 1199 ) {
    var nextOffsetTop = nextOffset.top - 80;
  } else {
    var nextOffsetTop = nextOffset.top - 70;
  }

    $('html, body').animate({
      scrollTop: nextOffsetTop + 'px'
    }, 750);

  });

  $('.dropdown').on('click',function(e) {
    $('.dropdown').not(this).removeClass('is-expanded');
    $(this).toggleClass('is-expanded');
  });

  $('.content-info--back-to-top').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 750);
  });

  //$('select').selectric();

  // Add class to body on hamburger click
  $('.navbar-toggler').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('menu-is-open');
  });

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';

  $('body').addClass('is-loaded').addClass(isIE11);

  // Detect if banner has been scrolled past
  var navScrolled = function() {

    var $window    = $(window);
    var docViewTop = 90;
    var nav        = $('.banner');
    var elemTop    = $window.scrollTop();

    if ( elemTop > docViewTop ) {
      nav.addClass('scrolled');
    } else {
      nav.removeClass('scrolled');
    }

  };

  navScrolled();

  $( window ).scroll( function(e) {
    navScrolled();
  });

  if ( $('.blank').length > 0 ) {

    $('.blank').each( function(index, value) {
      $(this).find('a').attr('target','_blank').attr('rel','external noreferrer noopener');
    });

  }

});
